export const BUS_EVENTS = {
  SET_REFERRER_HOST: 'SET_REFERRER_HOST',
  SET_TWEET_REPLY: 'SET_TWEET_REPLY',
  CLOSE_COMMENT_MODE: 'CLOSE_COMMENT_MODE',
  SET_MESSAGE_CONVERSATION: 'SET_MESSAGE_CONVERSATION',
  CLEAR_CONVERSATION: 'CLEAR_CONVERSATION',
  CLOSE_NOTIFICATION: 'CLOSE_NOTIFICATION',
  ATTACHMENT_SIZE_CHECK_ERROR: 'ATTACHMENT_SIZE_CHECK_ERROR',
};
